import "./index.css";
import {forwardRef} from "react";

/**
 *
 * @type {
 *      React.ForwardRefExoticComponent<
 *          React.PropsWithoutRef<React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>>
 *              & React.RefAttributes<HTMLInputElement>
 *      >
 * }
 */
const Input = forwardRef(
    ({type = 'text', ...props}, ref) => {
        return (
            <input
                {...props}
                ref={ref}
                type={type}
                className="ui_input"
            />
        );
    }
);

export default Input;

